import { createStore } from 'vuex'
import axios from 'axios'
// import gemeenteData from '@/assets/geo/wijk_gemeente_2019_v3.json';

import {csv, json} from 'd3-fetch';

export default createStore({
  state: {
    data: {},
    step: {},
    gmCode: undefined,
    buurtCode: undefined,
    buurten: {},
    gemeenteData: undefined,
    firstSearch: true,
    buurtData: undefined,
    buurtInfo: {}
  },
  mutations: {
    SAVE_DATA (state, data) {
      state.data = data.data;
    }, 

    UPDATE_STEP(state, step) {
      state.step = step;
    },

    ON_SEARCH(state, query) {
      state.gmCode = query;

      let gemeentenBuurten = state.gemeenteData.objects.wijk.geometries
        .filter(d => d.properties.GM_CODE === query).map(d => d.properties)
      state.buurten[query] = gemeentenBuurten;
    },

    SET_BUURT(state, query) {
      state.buurtCode = query;
    },

    SAVE_GEMEENTE_DATA(state, data) {
      state.gemeenteData = data;
    },

    SET_BUURT_INFO(state) {
      if(!state.buurtData) return;
      
      let indexGemeente = state.buurtData.findIndex(d => {return d.codering === state.gmCode});
      let indexBuurt = state.buurtData.findIndex(d => {return d.codering === state.buurtCode});
      let indexNL = state.buurtData.findIndex(d => {return d.codering === 'NL01'});
      
      state.buurtInfo = { 
        nl: state.buurtData[indexNL], 
        gemeente: state.buurtData[indexGemeente], 
        buurt: state.buurtData[indexBuurt] 
      }
    },

    SAVE_BUURT_DATA(state, data) {
      state.firstSearch = false;
      state.buurtData = data;
    }
  },
  getters: {
    step: state => state.step,
    gmCode: state => state.gmCode,
    buurtCode: state => state.buurtCode,
    buurten: state => state.buurten[state.gmCode],
    buurtInfo: state => state.buurtInfo
  },
  actions: {
    updateStep({commit}, step) {
      commit("UPDATE_STEP", step);
    },

    onSearch({commit}, query) {
      commit("ON_SEARCH", query);
    },

    onSetBuurt({commit}, query) {
      commit("SET_BUURT", query);
      commit("SET_BUURT_INFO");
    },

    loadData ({ commit, state }) {
      return new Promise((resolve, reject) => { 
        axios
          .get(process.env.VUE_APP_API)
          .then(result => {
            commit("SAVE_DATA", result.data);
            resolve();
          })
          .catch(error => {
            reject();
            throw new Error(`API ${error}`);
          });
      })
    },    

    loadGemeenteData ({ commit, state }) {
      return new Promise((resolve, reject) => { 
        json(`${process.env.BASE_URL}data/wijk_gemeente_2019_v3.json`)
          .then(result => {
            commit("SAVE_GEMEENTE_DATA", result);
            resolve();
          })
          .catch(error => {
            reject();
            throw new Error(`API ${error}`);
          });
      })
    },    

    loadBuurtData ({ commit, state }) {
      return new Promise((resolve, reject) => { 
        csv(`${process.env.BASE_URL}data/details.csv`)
          .then(result => {
            commit("SAVE_BUURT_DATA", result);
            resolve();
          })
          .catch(error => {
            reject();
            throw new Error(`API ${error}`);
          });
      })
    },    

  },
  modules: {

  }
})
